<div *ngIf="employeeData" class="side-bar">
  <div class="side-nav">
    <div class="heading-container px-3 py-2 pt-3">
      <a href="javascript:void(0);" (click)="closeEmployeeSideNavBar()"
        ><img style="height: 12px; width: 12px" src="/assets/images/icon/close.svg"
      /></a>
    </div>
    <div class="sidenav-container">
      <div class="d-flex justify-content-between pb-5">
        <div class="card border-0">
          <div class="card-horizontal">
            <div class="img-square-wrapper">
              <img
                style="height: 120px; width: 115px; object-fit: fill"
                class=""
                [src]="employeeData?.avatar?.url || '/assets/images/employee_placeholder.jpg'"
                alt="User profile" />
            </div>
            <div class="card-body px-2 py-1">
              <h4
                [ngClass]="{
                  'card-title': true,
                  'mb-1': true,
                  'text-success': employeeData?.status,
                  'text-muted': !employeeData?.status
                }">
                {{ employeeData?.status ? 'ACTIVE' : 'INACTIVE' }}
              </h4>
              <span class="card-text mb-1">{{
                employeeData?.employeeAlias !== '' && employeeData?.employeeAlias !== null
                  ? employeeData.employeeAlias
                  : employeeData.firstName + ' ' + employeeData.lastName
              }}</span>
              <br />
              <span class="card-text">{{ employeeData?.employeeTitle.name }}</span>
            </div>
          </div>
          <div class="card-body p-1">
            <p class="card-text mb-1">
              Pay Local: {{ employeeData?.employeeUnionLocal ? employeeData.employeeUnionLocal.name : 'N/A' }}
            </p>
            <p class="card-text mb-1">
              Home Local: {{ employeeData?.employeeHomeLocal ? employeeData.employeeHomeLocal.name : 'N/A' }}
            </p>
          </div>
          <hr class="my-2" />
          <div class="card-body p-1">
            <p class="card-text mb-1">
              <img class="mr-2" src="/assets/images/icon/location.svg" />{{ employeeData?.city }}
            </p>
            <p class="card-text mb-1">
              <img class="mr-2" src="/assets/images/icon/phone.svg" /><a
                class="highlighted"
                href="tel:{{ employeeData?.phone }}"
                >{{ employeeData?.phone }}</a
              >
            </p>
            <p class="card-text mb-1">
              <img class="mr-2" src="/assets/images/icon/mail.svg" /><a
                class="highlighted"
                href="mailto:{{ employeeData?.email }}"
                >{{ employeeData?.email }}</a
              >
            </p>
          </div>
          <div class="card-body p-1">
            <p
              *ngIf="isAllowed('job_board_attributes', 'edit') && isAllowed('job_pointe_employees', 'edit')"
              class="card-text mb-1">
              Hourly Rate: TBD
            </p>
            <p
              *ngIf="isAllowed('job_board_attributes', 'edit') && isAllowed('job_pointe_employees', 'edit')"
              class="card-text mb-1">
              DOB: {{ formatDate(employeeData?.dateOfBirth) }}
            </p>
            <p class="card-text mb-1">DOH: {{ formatDate(employeeData?.dateOfHire) }}</p>
          </div>
          <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="w-100">
            <a
              (click)="viewProfile()"
              href="javascript:void(0);"
              class="btn btn-primary view-profile-btn"
              style="width: inherit"
              >View Full Profile</a
            >
          </div>
          <hr class="my-2" />
          <div class="certification-group">
            <p class="my-1" id="certification-title">Certifications</p>
            <ul *ngFor="let attr of employeeData?.jobBoardAttributes" class="list-group">
              <li *ngIf="attr?.status" class="list-group-item">
                <span class="bold font-weight-bolder">{{ attr?.jobBoardAttribute?.name }}</span>
                <span class="expiration-date" *ngIf="attr?.expirationDate">
                  (Exp. {{ formatDate(attr?.expirationDate) }})</span
                >
              </li>
            </ul>
          </div>
          <hr class="my-2" />
          <div class="tags-group">
            <p class="my-1" id="tags-title">TAGS</p>
            <div class="list-group-container">
              <ul class="list-group draggable-box">
                <li *ngFor="let ta of tagAssignments" class="list-group-item">
                  <app-job-board-tags
                    [removable]="true"
                    (delete)="removeCardTag(ta)"
                    [tag]="ta?.tag"
                    [tagShape]="ta?.tag?.shape"></app-job-board-tags>
                </li>
              </ul>
            </div>
          </div>
          <hr class="my-2" />
          <div>
            <p class="my-1" id="employee-assignment-title">Employee Assignments</p>
            <div class="list-group-container">
              <ul class="py-1 px-0">
                <ng-container *ngFor="let employee of employeeData?.jobBoardJobs">
                  <li class="list-group-item">
                    <ng-container *ngIf="employee?.facility">
                      <ng-container *ngIf="employee?.facility?.owner">
                        {{ employee?.facility?.owner?.ownerName }}
                      </ng-container>
                      | {{ employee.facility.facilityName }}
                    </ng-container>
                    <ng-container *ngIf="employee?.job?.jobNumber">
                      {{ employee?.job?.jobNumber }} | {{ employee?.job?.name }}
                    </ng-container>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
          <hr class="my-2" />
          <div *ngIf="isAllowed('job_board_attributes', 'edit') && isAllowed('job_pointe_employees', 'edit')">
            <p class="my-1" id="notes-title">NOTES</p>
               <textarea readonly rows="5" class="w-100">{{ latestNote }}</textarea>
          </div>
          <!-- Employee Note Logs -->
          <div *ngIf="otherNotes.length" class="notes-container">
            <div *ngFor="let note of otherNotes">
              <div class="note d-flex justify-content-between">
                <strong>{{ note.createdAt | date: 'shortDate' }}</strong>
                <p class="note-content">{{ note.note }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
